/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { ClientDetailsDto } from '../models/client-details-dto';
import { ClientDto } from '../models/client-dto';
import { CreateClientDto } from '../models/create-client-dto';
import { UpdateClientDto } from '../models/update-client-dto';


/**
 * API to manage clients.
 */
@Injectable({
  providedIn: 'root',
})
export class ClientsService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation clientsSearch
   */
  static readonly ClientsSearchPath = '/v1/clients';

  /**
   * Permissions: core.clients.search
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `clientsSearch()` instead.
   *
   * This method doesn't expect any request body.
   */
  clientsSearch$Response(params?: {
    PageSize?: number;
    PageIndex?: number;
  }): Observable<StrictHttpResponse<Array<ClientDto>>> {

    const rb = new RequestBuilder(this.rootUrl, ClientsService.ClientsSearchPath, 'get');
    if (params) {
      rb.query('PageSize', params.PageSize, {});
      rb.query('PageIndex', params.PageIndex, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<ClientDto>>;
      })
    );
  }

  /**
   * Permissions: core.clients.search
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `clientsSearch$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  clientsSearch(params?: {
    PageSize?: number;
    PageIndex?: number;
  }): Observable<Array<ClientDto>> {

    return this.clientsSearch$Response(params).pipe(
      map((r: StrictHttpResponse<Array<ClientDto>>) => r.body as Array<ClientDto>)
    );
  }

  /**
   * Path part for operation clientsPost
   */
  static readonly ClientsPostPath = '/v1/clients';

  /**
   * Permissions: core.clients.create
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `clientsPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  clientsPost$Response(params: {
    body: CreateClientDto
  }): Observable<StrictHttpResponse<number>> {

    const rb = new RequestBuilder(this.rootUrl, ClientsService.ClientsPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: parseFloat(String((r as HttpResponse<any>).body)) }) as StrictHttpResponse<number>;
      })
    );
  }

  /**
   * Permissions: core.clients.create
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `clientsPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  clientsPost(params: {
    body: CreateClientDto
  }): Observable<number> {

    return this.clientsPost$Response(params).pipe(
      map((r: StrictHttpResponse<number>) => r.body as number)
    );
  }

  /**
   * Path part for operation clientsGet
   */
  static readonly ClientsGetPath = '/v1/clients/{id}';

  /**
   * Permissions: core.clients.get
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `clientsGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  clientsGet$Response(params: {
    id: number;
  }): Observable<StrictHttpResponse<ClientDetailsDto>> {

    const rb = new RequestBuilder(this.rootUrl, ClientsService.ClientsGetPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ClientDetailsDto>;
      })
    );
  }

  /**
   * Permissions: core.clients.get
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `clientsGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  clientsGet(params: {
    id: number;
  }): Observable<ClientDetailsDto> {

    return this.clientsGet$Response(params).pipe(
      map((r: StrictHttpResponse<ClientDetailsDto>) => r.body as ClientDetailsDto)
    );
  }

  /**
   * Path part for operation clientsPut
   */
  static readonly ClientsPutPath = '/v1/clients/{id}';

  /**
   * Permissions: core.clients.update
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `clientsPut()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  clientsPut$Response(params: {
    id: number;
    body: UpdateClientDto
  }): Observable<StrictHttpResponse<number>> {

    const rb = new RequestBuilder(this.rootUrl, ClientsService.ClientsPutPath, 'put');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: parseFloat(String((r as HttpResponse<any>).body)) }) as StrictHttpResponse<number>;
      })
    );
  }

  /**
   * Permissions: core.clients.update
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `clientsPut$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  clientsPut(params: {
    id: number;
    body: UpdateClientDto
  }): Observable<number> {

    return this.clientsPut$Response(params).pipe(
      map((r: StrictHttpResponse<number>) => r.body as number)
    );
  }

  /**
   * Path part for operation clientsDelete
   */
  static readonly ClientsDeletePath = '/v1/clients/{id}';

  /**
   * Permissions: core.clients.delete
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `clientsDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  clientsDelete$Response(params: {
    id: number;
  }): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, ClientsService.ClientsDeletePath, 'delete');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Permissions: core.clients.delete
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `clientsDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  clientsDelete(params: {
    id: number;
  }): Observable<void> {

    return this.clientsDelete$Response(params).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

}
